import { useState, useCallback, useEffect } from 'react';

/**
 * useNestingNotification Hook
 * 
 * Handles the nesting completion notification state.
 * Shows a brief notification when campaign nesting completes.
 * 
 * @param {boolean} isNesting - Whether nesting is in progress
 * @param {Function} handleNestCampaign - Base nesting handler
 * @returns {{ nestingComplete, handleNestCampaignWithNotification }}
 */
export function useNestingNotification(isNesting, handleNestCampaign) {
  const [nestingComplete, setNestingComplete] = useState(false);

  useEffect(() => {
    if (!isNesting && nestingComplete) {
      const timer = setTimeout(() => setNestingComplete(false), 2500);
      return () => clearTimeout(timer);
    }
  }, [isNesting, nestingComplete]);

  const handleNestCampaignWithNotification = useCallback(async (...args) => {
    setNestingComplete(true);
    await handleNestCampaign(...args);
  }, [handleNestCampaign]);

  return {
    nestingComplete,
    handleNestCampaignWithNotification,
  };
}
